import { logAnalytics } from '../utils/khazaddumbridge';
export default class BaseEvent {
    fireEvent() {
        logAnalytics(this.eventName, JSON.stringify(this.toJSON()));
        this.reset();
    }
    toJSON() {
        return Object.assign({}, this);
    }
}
//# sourceMappingURL=BaseEvent.js.map